<script>
    import { createEventDispatcher } from 'svelte';
    import { newTerm } from "../../libs/typefactories";
    import AdvancedFilters from "./AdvancedFilters.svelte";
    import OPTS from '../../libs/options';

    const dispatch = createEventDispatcher();
    let term = '';

    function searchHandler() {
        const values = [];
        if (term) {
            values.push(newTerm(term));
            term = '';
        }

        if (values.length) {
            dispatch('search', values);
        }
    }

    function keyPressHandler(event) {
        if (event.key === 'Enter') {
            searchHandler()
        }
    }
</script>
<div class="c-search-bar">
    <div class="c-search-bar__item">
        <div class="c-search-field">
            <label class="c-search-field__label">
                <span class="u-screen-reader-only">Aggiungi termine di ricerca</span>
                <input bind:value={term} on:keyup={keyPressHandler} type="search" class="c-search-field__input" placeholder="Cerca" name="s">
            </label>
            <button type="button" class="c-search-field__submit-button" on:click|preventDefault={searchHandler}>
                <span class="u-screen-reader-only">Cerca</span>
                <i class="fas fa-search"></i>
            </button>
        </div>
    </div>
    <div class="c-search-bar__separator"></div>
    <div class="c-search-bar__item c-search-bar__item--others">
        {#if OPTS.advanced_fields.length}
            <AdvancedFilters on:search />
        {/if}
    </div>
</div>